// ----------- Version -----------
export * from './lib/version';

// ----------- Constants -----------
export * from './lib/constants/constants';
export * from './lib/constants/autogen_internal';

// ----------- Interfaces -----------
export * from './lib/interfaces/i-errors';

// ----------- ENUMS -----------
export * from './lib/enums';

// ----------- Errors -----------
export * from './lib/errors';

// ----------- Utils -----------
export * from './lib/utils/utils';

// ----------- ABIs -----------
import * as ABI_LIT from './lib/abis/LIT.json';
import * as ABI_ERC20 from './lib/abis/ERC20.json';

export { ABI_LIT, ABI_ERC20 };
